import axiosInstance from '../utils/axiosInstance';
import config from '../utils/config';
import { extractErrorMessage } from '../utils/extractErrorMessage';
import type { AnalysisParameterContractsResponse, AnalysisParameters, AnalysisRebuildStatus,
  DeviceAnalysisParametersResponse, SaveAnalysisParametersResponse } from '../types';

const base = () => `${config.devicesApiUrl}/analysis-methods`;
const assignment = (analysisKey: string, deviceId: number) => `${base()}/${encodeURIComponent(analysisKey)}/devices/${deviceId}`;

export async function fetchAnalysisParameterContracts(): Promise<AnalysisParameterContractsResponse> {
  return (await axiosInstance.get<AnalysisParameterContractsResponse>(`${base()}/parameter-contracts`)).data;
}
export async function fetchDeviceAnalysisParameters(deviceId: number): Promise<DeviceAnalysisParametersResponse> {
  return (await axiosInstance.get<DeviceAnalysisParametersResponse>(`${base()}/devices/${deviceId}/parameters`)).data;
}
export async function saveAnalysisParameters(analysisKey: string, deviceId: number,
  paramsOverride: AnalysisParameters, rebuild = false): Promise<SaveAnalysisParametersResponse> {
  return (await axiosInstance.put<SaveAnalysisParametersResponse>(`${assignment(analysisKey, deviceId)}/parameters`,
    { params_override: paramsOverride, rebuild })).data;
}
export async function fetchAnalysisRebuildStatus(analysisKey: string, deviceId: number): Promise<AnalysisRebuildStatus> {
  return (await axiosInstance.get<AnalysisRebuildStatus>(`${assignment(analysisKey, deviceId)}/rebuild-status`)).data;
}

/** Worker validation and availability messages are actionable text; keep them verbatim. */
export function analysisParameterError(error: unknown): string {
  return extractErrorMessage(error, 'Request failed', { verbatimMessage: true });
}
